import {
  Environment,
  middlewareTypes,
  createFetchPolicyMiddleware,
  createErrorMiddleware,
  Store,
} from '@bingads-webui-react/overreact';
import { schema } from './schema';

export { getRequestor } from './requestor';

export const middlewares = {
  [middlewareTypes.FETCH_POLICY]: createFetchPolicyMiddleware(),
  [middlewareTypes.ERROR]: createErrorMiddleware(),
};

const store = new Store();
let env = null;

export const AD_INSIGHT_ENVIRONMENT_TAG = 'Ad_Insight_Endpoint';

export function getEnvironmentInstance(requestor, customStore, customMiddleWares) {
  if (!env) {
    env = new Environment(
      requestor,
      schema,
      customStore || store,
      customMiddleWares || middlewares,
      AD_INSIGHT_ENVIRONMENT_TAG
    );
  }
  // allow caller to update requestor
  env.networkRequestor = requestor;
  env.middlewares = customMiddleWares || middlewares;

  return env;
}

export function environmentLookupFn(environmentTag) {
  return environmentTag === AD_INSIGHT_ENVIRONMENT_TAG;
}
